import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Image,
  Container,
} from "react-bootstrap";

import "./Sort.css";
import { RxCross2 } from "react-icons/rx";
import Slider from "rc-slider";
import { MdFlight } from "react-icons/md";
function Sort({
 clearAllFilters, closeFilter, setSortType, sortType

}) {
  return (
     <div className="mobile heading_flight_list_two heading_flight_list_three heading_flight_list_four">
      <div className="actpop fltr-pop" id="idflr">
        <div className="popbx">
          <div className="close-btn fltPop" onClick={closeFilter}>✕</div>
          <div className="ovf-sc">

            <Container className="sort-options-container heading_flight_list_three">
              {/* Row 1 */}
              <Row className="sort-row">
                <Col className="sort-option">
                  <input
                    type="radio"
                    name="sort"
                    id="sort-price"
                    checked={sortType === "price"}
                    onChange={() => setSortType("price")}
                  />
                  <div className="sort-label">
                    <span className="sort-title">Price</span>
                    <div className="sort-subtitle">Low to High</div>
                  </div>
                </Col>

                <Col className="sort-option">
                  <input
                    type="radio"
                    name="sort"
                    id="sort-departure"
                    checked={sortType === "departure"}
                    onChange={() => setSortType("departure")}
                  />
                  <div className="sort-label">
                    <span className="sort-title">Departure</span>
                    <div className="sort-subtitle">Earliest First</div>
                  </div>
                </Col>
              </Row>

              {/* Row 2 */}
              <Row className="sort-row">
                <Col className="sort-option">
                  <input
                    type="radio"
                    name="sort"
                    id="sort-fastest"
                    checked={sortType === "fastest"}
                    onChange={() => setSortType("fastest")}
                  />
                  <div className="sort-label">
                    <span className="sort-title">Fastest</span>
                    <div className="sort-subtitle">Shortest First</div>
                  </div>
                </Col>

                <Col className="sort-option">
                  <input
                    type="radio"
                    name="sort"
                    id="sort-smart"
                    checked={sortType === "smart"}
                    onChange={() => setSortType("smart")}
                  />
                  <div className="sort-label">
                    <span className="sort-title">Smart</span>
                    <div className="sort-subtitle">Recommended</div>
                  </div>
                </Col>
              </Row>
            </Container>

            <div className="text-wrapper">
              <div className="sort-heading">Smart Sort?</div>
              <div className="sort-body">
                Flights are sorted based on price, duration, stops & other factors.
              </div>
            </div>

            <div className="apl-btn" style={{ display: "flex", justifyContent: "space-between" }}>
              <div onClick={clearAllFilters} className="clear-btn">Clear</div>
              <a onClick={closeFilter} className="slt-st goTopBtn">Apply</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sort;
